(function() {
  const slider = document.getElementById('slider');
  if (!slider) return;
  const dots = document.querySelectorAll('.gallery-dot');
  const sliderImages = slider.querySelectorAll('img');
  let currentSlide = 0;
  const totalSlides = (typeof wp_total_images !== 'undefined' && wp_total_images > 0) ? wp_total_images : (window.product_data?.images?.length || sliderImages.length || 5);

  function updateSlider() {
    slider.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
    dots.forEach(function(dot, i) {
      if (i === currentSlide) {
        dot.classList.remove('bg-muted/40');
        dot.classList.add('bg-lime');
      } else {
        dot.classList.remove('bg-lime');
        dot.classList.add('bg-muted/40');
      }
    });
  }
  window.slideGallery = function(dir) {
    currentSlide = (currentSlide + dir + totalSlides) % totalSlides;
    updateSlider();
  };
  window.goToSlide = function(index) {
    currentSlide = index;
    updateSlider();
  };
  let touchStartX = 0;
  slider.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].screenX;
  }, false);
  slider.addEventListener('touchend', function(e) {
    const endX = e.changedTouches[0].screenX;
    if (touchStartX - endX > 50) slideGallery(1);
    if (endX - touchStartX > 50) slideGallery(-1);
  }, false);
})();
(function() {
  const reviewSlider = document.getElementById('reviewSlider');
  const reviewImages = document.querySelectorAll('.review-img');
  if (!reviewSlider || !reviewImages.length) return;
  let reviewIndex = 0;
  const totalReviews = reviewImages.length;
  const imgEl = document.getElementById('reviewSliderImg');
  const userEl = document.getElementById('reviewSliderUser');
  const counterEl = document.getElementById('reviewCounter');
  const starsEl = document.getElementById('reviewSliderStars');
  if (!imgEl || !userEl || !counterEl || !starsEl) return;

  function updateReviewSlider() {
    const img = reviewImages[reviewIndex];
    imgEl.src = img.src;
    userEl.textContent = img.dataset.user || '';
    counterEl.textContent = (reviewIndex + 1) + ' / ' + totalReviews;
    const rating = parseInt(img.dataset.rating, 10) || 0;
    let stars = '';
    for (let i = 0; i < 5; i++) {
      stars += i < rating ? ' < i class = "fas fa-star" > < /i>' : ' < i class = "fa-regular fa-star" > < /i>';
    }
    starsEl.innerHTML = stars;
  }
  window.openReviewSlider = function(index) {
    reviewIndex = index;
    updateReviewSlider();
    reviewSlider.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  };
  window.closeReviewSlider = function() {
    reviewSlider.classList.add('hidden');
    document.body.style.overflow = '';
  };
  window.slideReview = function(dir) {
    reviewIndex = (reviewIndex + dir + totalReviews) % totalReviews;
    updateReviewSlider();
  };
  document.addEventListener('keydown', function(e) {
    if (reviewSlider.classList.contains('hidden')) return;
    if (e.key === 'Escape') closeReviewSlider();
    if (e.key === 'ArrowLeft') slideReview(-1);
    if (e.key === 'ArrowRight') slideReview(1);
  });
  let touchStartX = 0;
  reviewSlider.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].screenX;
  });
  reviewSlider.addEventListener('touchend', function(e) {
    const diff = touchStartX - e.changedTouches[0].screenX;
    if (Math.abs(diff) > 50) slideReview(diff > 0 ? 1 : -1);
  });
})();
window.toggleFaq = function(btn) {
  if (!btn) return;
  const item = btn.parentElement;
  if (!item) return;
  const content = item.querySelector('.faq-content');
  const icon = btn.querySelector('i');
  if (!content || !icon) return;
  document.querySelectorAll('.faq-item').forEach(function(otherItem) {
    if (otherItem !== item) {
      const otherContent = otherItem.querySelector('.faq-content');
      const otherIcon = otherItem.querySelector('button i');
      if (otherContent) otherContent.classList.add('hidden');
      if (otherIcon) otherIcon.classList.remove('rotate-45');
    }
  });
  content.classList.toggle('hidden');
  icon.classList.toggle('rotate-45');
};
